<template>
  <div class="" style="margin-top: 10px">
    <div class="flex align-items-center justify-content-center">
      <MegaMenu
        :model="cupAdminMenuItems"
        :activeIndex="activeMenuItem ? activeMenuItem.index : -1"
        style="margin-top: 10px; min-width: 200px; display: flex; justify-content: center"
      >
        <template #item="{ item }">
          <a
            class="p-menuitem-link"
            @click="onItemClick(item)"
            :style="
              'display: flex; flex-direction: column; padding: 5px 6px;border: solid' +
              (item.active ? ';color: #2196f3' : '#dee2e6') +
              ';border-width: 0 0 3px 0;' +
              (item.active ? ';color: #2196f3' : '')
            "
          >
            <span v-if="item.icon" :class="item.icon" style="font-size: 38px"></span>
            <span
              class="p-menuitem-text"
              :style="
                'margin-top: 8px; font-size: 12px; font-weight: 600;' +
                (item.active ? ';color: #2196f3' : '')
              "
              >{{ item.label }}</span
            >
          </a>
        </template>
      </MegaMenu>
    </div>
    <div v-if="activeMenuItem && activeMenuItem.name == 'pokal'">
      <div
        v-if="cupLeagueMissing && cupScope && isSeasonManager()"
        class="flex align-items-center justify-content-center"
        style="margin-top: 10px"
      >
        <div style="width: 100%; max-width: 1000px">
          <CupCreationView :scope="cupScope" @created="cupCreated" />
        </div>
      </div>
      <div v-if="!cupLeagueMissing">
        <div v-if="nextRoundDrawPossible">
          <ProgressSpinner v-if="nextRoundDrawInProgress" style="margin-top: 20px" />
          <Button
            v-else
            style="margin: 20px 2px"
            label="Auslosung der nächsten Pokalrunde ausführen"
            icon="pi pi-receipt"
            class="p-button-rounded p-button-warn mb2"
            @click="showNextDrawDialog()"
          />
        </div>
        <div v-else class="flex flex-column align-items-center justify-content-center">
          <Button
            style="margin: 20px 2px 0px 2px"
            label="Auslosung der nächsten Pokalrunde ausführen"
            icon="pi pi-receipt"
            class="p-button-rounded p-button-warn mb2"
            disabled
          />
          <Message
            severity="warn"
            :closable="false"
            style="margin: 0px; margin-bottom: 10px; max-width: 350px"
            >Die laufende Runde ist noch nicht vorbei</Message
          >
        </div>

        <TeamAdminCupView :leagueId="leagueId" :currentTeamId="0" ref="teamAdminCupView" />
      </div>
    </div>
  </div>
  <Dialog v-model:visible="displayNextDrawDialog" :closable="false">
    <template #header>
      <h3>Neue Runde auslosen?</h3>
    </template>
    <span
      >Danach sind keine Änderungen mehr möglich. Stehen noch Sieger einer Vorrunde aus,
      werden diese zuerst in die bereits ausgeloste Runde eingetragen. Spiele der laufenden
      Runde ohne Ergebnis, etwa verlegte, gehen als „Sieger (X : Y)“ in die Auslosung ein;
      der Sieger wird eingetragen, sobald das Ergebnis vorliegt.</span
    >
    <template #footer>
      <Button
        label="Ausführen"
        icon="pi pi-check"
        class="p-button-text"
        @click="executeNextRoundDraw"
      />
      <Button label="Abbrechen" icon="pi pi-times" @click="cancelNextRoundDraw" />
    </template>
  </Dialog>
</template>

<script>
import { useMenuService } from "../../services/MenuService/UseMenuService";
import UserPermissionsService from "../../services/UserPermissionsService/UserPermissionsService";
import ServerConnection from "../../services/ServerConnection/ServerConnection";
import FailureHandler from "../../services/ServerConnection/FailureHandler";
import MegaMenu from "primevue/megamenu";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import ProgressSpinner from "primevue/progressspinner";
import { useWizardService } from "../../services/WizardService/UseWizardService";
import TeamAdminCupView from "../teamAdmin/TeamAdminCupView";
import CupCreationView from "./CupCreationView.vue";
import Message from "primevue/message";
import { setActiveMenuItemByName } from "../../services/MenuService/MenuItemStateUtils";
const cupMenuItem = {
  index: 2,
  name: "pokal",
  label: "Pokal",
  icon: "pi pi-fw pi-sitemap",
  style: "padding: 0px 1px",
  active: false,
  items: [],
};
const cloneMenuItem = (menuItem) => JSON.parse(JSON.stringify(menuItem));

export default {
  name: "CupAdminDashBoard",
  emits: ["created"],
  components: {
    MegaMenu,
    Button,
    Dialog,
    TeamAdminCupView,
    CupCreationView,
    Message,
    ProgressSpinner,
  },
  computed: {
    loggedIn() {
      var user = localStorage.getItem("user");
      return user && user != null;
    },
    showSignOffDialog() {
      return this.signOffPlayer && this.signOffPlayer != null;
    },
    cupAdminMenuItems() {
      var menuItems = [cloneMenuItem(cupMenuItem)];
      var activeMenuItemName;
      if (this.activeMenuItem) {
        activeMenuItemName = this.activeMenuItem.name;
      } else {
        activeMenuItemName = localStorage.getItem("activeMenuItemName");
      }
      this.handleMenuItemAktiveByName(activeMenuItemName, menuItems);
      return menuItems;
    },
  },
  data() {
    return {
      menuService: useMenuService(),
      wizardService: useWizardService(),
      mannschaften: [],
      currentMannschaft: null,
      gameDayViewIndex: -1,
      activeMenuItem: null,
      editPlayer: null,
      signOffPlayer: null,
      displayNextDrawDialog: false,
      nextRoundDrawPossible: false,
      nextRoundDrawInProgress: false,
      refreshIntervalId: null,
    };
  },
  props: {
    leagueId: {
      type: Number,
      required: true,
    },
    cupLeagueMissing: {
      type: Boolean,
      default: false,
    },
    cupScope: {
      type: String,
      default: null,
    },
  },
  created() {
    this.ensureActiveMenuItem();
    this.updateMainMenu();
    if (!this.cupLeagueMissing) {
      this.loadNextRoundDrawPossible();
    }
  },
  mounted() {
    if (this.cupLeagueMissing) {
      return;
    }
    this.refreshIntervalId = setInterval(() => {
      this.loadNextRoundDrawPossible();
    }, 60 * 1000);
  },
  beforeUnmount() {
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
      this.refreshIntervalId = null;
    }
  },
  watch: {
    loggedIn: {
      immediate: true,
      handler(isLoggedIn) {
        if (!isLoggedIn) {
          this.$router.push("/login");
        }
      },
    },
    activeMenuItem() {
      this.ensureActiveMenuItem();
      this.updateMainMenu();
    },
  },
  methods: {
    isSeasonManager() {
      return UserPermissionsService.userHasRole("SEASON_MANAGER");
    },
    cupCreated() {
      if (!this.cupLeagueMissing) {
        if (this.$refs.teamAdminCupView) {
          this.$refs.teamAdminCupView.resetData();
        }
        this.loadNextRoundDrawPossible();
      }
      this.$emit("created");
    },
    ensureActiveMenuItem() {
      if (!this.activeMenuItem) {
        this.activeMenuItem = { name: "pokal", index: 2 };
      }
    },
    loadNextRoundDrawPossible() {
      ServerConnection.get("cup/"+this.leagueId+"/nextRoundDrawPossible")
        .then((response) => response.data)
        .then((data) => {
          this.nextRoundDrawPossible = data;
        })
        .catch((error) => {
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    showNextDrawDialog() {
      this.displayNextDrawDialog = true;
    },
    cancelNextRoundDraw() {
      this.displayNextDrawDialog = false;
    },
    executeNextRoundDraw() {
      this.nextRoundDrawInProgress = true;
      this.displayNextDrawDialog = false;
      ServerConnection.put("cup/"+this.leagueId+"/executeNextRoundDraw")
        .then(() => {
          this.$refs.teamAdminCupView.resetData();
          this.loadNextRoundDrawPossible();
          this.nextRoundDrawInProgress = false;
        })
        .catch((error) => {
          this.nextRoundDrawInProgress = false;
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    updateMainMenu() {
      this.menuService.setMainMenuItemNames(["messages", "settings", "help", "logout"]);
    },
    onItemClick(item) {
      this.activeMenuItem = { name: item.name, index: item.index };
      localStorage.setItem("activeMenuItemName", item.name);
    },
    handleMenuItemAktiveByName(name, items) {
      return setActiveMenuItemByName(name, items);
    },
    currentTeamPlaysCup() {
      return this.currentMannschaft && this.currentMannschaft.registeredForCup;
    },
  },
};
</script>
